import axios from "axios"

export const checkExistSubscription = async (subscriptionNumber: string) => {
    const response = await axios.post(`/network/ra/exist-from-subscription`, null, {params: {subscriptionNumber} });
    return response.data;
}